module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Anchor-left-up-178ee9c3cb7cf3085987113828b44d25.svg";